import * as React from 'react';

import cx from 'classnames';

interface Props {
  hasOutline: boolean;
  a11yLabel?: string;
}

export function InfoIcon({ hasOutline, a11yLabel }: Props) {
  const iconClass = React.useMemo(
    () =>
      cx(
        'flex flex-none items-center justify-center w-9 h-9 bg-white rounded-round text-grey-300 select-none pointer-events-none',
        { 'shadow-inner-outline': hasOutline }
      ),
    [hasOutline]
  );

  return (
    <div className={iconClass}>
      {a11yLabel ? (
        <div className="relative">
          <div className="sr-only">{a11yLabel}</div>
        </div>
      ) : null}
      <div
        aria-hidden="true"
        className="relative top-px font-display font-700 text-blue-600 text-base"
      >
        i
      </div>
    </div>
  );
}
